var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"asc-pdf-content"},[(_vm.bookmarks.length)?_c('v-navigation-drawer',{class:[
      'asc-pdf-content--menu',
      _vm.stickyMenu ? 'asc-pdf-content--menu-sticky' : null ],attrs:{"absolute":"","permanent":"","width":_vm.menuWidth}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":_vm.getColor,"height":4}}):_vm._e(),(_vm.loading)?_c('div',{class:[
        _vm.bookmarks && _vm.bookmarks.length && _vm.loading
          ? 'asc-pdf-content--menu-loading'
          : null ]}):_vm._e(),_c('asc-side-navigation',{attrs:{"side-items":_vm.bookmarks},model:{value:(_vm.bookmarkSelection),callback:function ($$v) {_vm.bookmarkSelection=$$v},expression:"bookmarkSelection"}})],1):_vm._e(),_c('v-container',{class:[
      'fill-height asc-pdf-content--container',
      _vm.bookmarks.length ? 'asc-pdf-content--container-hasMenu' : null ],style:({
      'padding-left': !_vm.stickyMenu
        ? ((_vm.menuWidth + 5) + "px")
        : _vm.bookmarks.length
        ? ((0) + "px")
        : 0,
      width:
        _vm.bookmarks && _vm.bookmarks.length
          ? ("calc(100% - " + _vm.menuWidth + "px)")
          : '100%',
    })},_vm._l((_vm.pageCount),function(i){return _c('pdf',{key:i,staticClass:"asc-pdf-content--container-page",attrs:{"id":i,"page":i,"src":_vm.src},on:{"page-loaded":_vm.handleLoaded,"error":_vm.error}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }